<template>
    <label class="checkbox__label" :class="{error: error, disabled: disabled}">
        <input
            type="checkbox"
            class="checkbox__input"
            :class="{disabled: disabled}"
            :name="name"
            :value="item"
            :checked="checked"
            @input="onChange"
        />
        <span class="checkbox__text">{{ item }}</span>
    </label>
</template>

<script>
    export default {
        props: {
            item: [String, Number],
            checked: Boolean,
            onChange: Function,
            name: String,
            error: Boolean,
            disabled: Boolean
        }
    }
</script>

<style scoped lang="scss">
.checkbox__label {
    display: flex;
    align-items: flex-start;
    gap: 8px;
    padding: 10px 16px;
    border-radius: 6px;
    border: 1px solid #d1d1d6;
    background: #fff;
    cursor: pointer;
    transition: all 150ms linear;

    &:focus-visible:not(.disabled),
    &:hover:not(.disabled) {
        border-color: rgb(49, 130, 206);
        box-shadow: rgb(49, 130, 206) 0px 0px 0px 1px;
    }

    &.error {
        border-color: red;
    }

    &.disabled {
        pointer-events: none;
        cursor: default;
        opacity: 0.5;
    }
}

.checkbox__input {
    -webkit-appearance: none;
    appearance: none;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 16px;
    height: 16px;
    border-radius: 3px;
    border: 1px solid #d1d1d6;

    &:checked::before {
        display: block;
        content: '';
        width: 13px;
        height: 13px;
        box-shadow: inset 1em 1em #3056d3;
        transform-origin: bottom left;
        clip-path: polygon(14% 44%, 0 65%, 50% 100%, 100% 16%, 80% 0%, 43% 62%);
        transition: all 150ms linear;
    };
}

.checkbox__text {
    color: #1d1f20;
    font-family: "Mulish", sans-serif;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    
    &::first-letter {
        text-transform: capitalize;
    }
}
</style>